module.exports = __webpack_public_path__ + "static/media/PingFangHK Regular-01.c19ff4da.svg";